export class Vector {
  x: number;

  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  static fromAngle(angle: number, magnitude: number) {
    return new Vector(magnitude * Math.cos(angle), magnitude * Math.sin(angle));
  }

  add(vector: Vector) {
    return new Vector(this.x + vector.x, this.y + vector.y);
  }

  subtract(vector: Vector) {
    return new Vector(this.x - vector.x, this.y - vector.y);
  }

  angle() {
    return Math.atan2(this.y, this.x);
  }
}
